export default function(ctx) {
  if (ctx.route.fullPath === '/lead-summary') ctx.redirect(301, '/leads')
}
